var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('v-container',{attrs:{"id":"content-container","fluid":"","fill-height":""}},[_c('v-layout',[_c('v-flex',[_c('CustomMap',{key:_vm.componentKey})],1)],1)],1),_c('CustomMenuRight'),_c('PointOfInterestModal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }